// extracted by mini-css-extract-plugin
export var numpadContainer = "_lp-1";
export var phoneButton = "_lp-0";